import { useState, useEffect } from "react";
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
import "../css/PoemsEnglish.css";
import { Helmet } from "react-helmet";
import { HerHappinessMyPeace } from "../components/PoemEnglish/HerHappinessMyPeace";
import { TimelessBeauty } from "../components/PoemEnglish/TimelessBeauty";
import { EgosInferno } from "../components/PoemEnglish/EgosInferno";
import { VillaininLove } from "../components/PoemEnglish/VillainInLove";
import { UnveiledByYou } from "../components/PoemEnglish/UnveiledByYou";
import { BetterAlone } from "../components/PoemEnglish/BetterAlone";
import { ForeverYoursMyQueen } from "../components/PoemEnglish/ForeverYoursMyQueen";
import { RelationshipisWorship } from "../components/PoemEnglish/RelationshipisWorship";


export const PoemsEnglish = () => {
    // State to manage the visibility of each modal
    const [showTimelessBeauty, setShowTimelessBeauty] = useState(false);
    const [showHerHappinessMyPeace, setShowHerHappinessMyPeace] = useState(false);
    const [showEgosInferno, setShowEgosInferno] = useState(false);
    const [showVillaininLove, setShowVillaininLove] = useState(false);
    const [showUnveiledByYou, setShowUnveiledByYou] = useState(false);
    const [showBetterAlone, setShowBetterAlone] = useState(false);
    const [showForeverYoursMyQueen, setShowForeverYoursMyQueen] = useState(false);
    const [showRelationshipisWorship, setShowRelationshipisWorship] = useState(false);
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            easing: 'ease-in-out', // Animation easing
            once: false, // Only animate once
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>Privacy Policy | Lone Wolf Writes</title>
                <meta name="description" content=" Poems | Lone Wolf Writes " />
                <link rel="canonical" href="https://lonewolfwrites.com/poems-eng" />
            </Helmet>
            <main>
                <div className="container">
                    <h1 style={{ textAlign: "center", fontSize: "largest", marginBottom: "40px" }}>Poems</h1>
                    <div className="row mt-4">
                        <div className="col-md-3 mb-4" data-aos="fade-up" >
                            <div className="card" style={{ border: "none", }} >
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowTimelessBeauty(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/timeless-beauty.jpg" alt="  | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Timeless Beauty
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowHerHappinessMyPeace(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/her-happiness-my-peace.jpg" alt=" Her Happiness, My Peace | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Her Happiness, My Peace
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowEgosInferno(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/egos-inferno.jpg" alt=" Ego's Inferno | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Ego's Inferno
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowVillaininLove(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/villain-in-love.jpg" alt=" Villain in Love | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Villain in Love
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-3 mb-4" data-aos="fade-up" >
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <div className="poemeng">
                                        <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowUnveiledByYou(true)} >
                                            <picture><img className="img-fluid rounded" src="/media/poemseng/unveiled-by-your-smile.jpg" alt=" Unveiled by You | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                            Unveiled by You
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowBetterAlone(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/better-alone.jpg" alt=" Better Alone | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Better Alone
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowForeverYoursMyQueen(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/need-you-the-most.jpg" alt=" Forever Yours, My Queen | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Forever Yours, My Queen
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowRelationshipisWorship(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemseng/relationship-is-worship.jpg" alt=" Relationship is Worship | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture>
                                        Relationship is Worship
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Modals */}
            {
                showTimelessBeauty && (
                    <TimelessBeauty onClose={() => setShowTimelessBeauty(false)} />
                )
            }
            {
                showHerHappinessMyPeace && (
                    <HerHappinessMyPeace onClose={() => setShowHerHappinessMyPeace(false)} />
                )
            }
            {showEgosInferno && <EgosInferno onClose={() => setShowEgosInferno(false)} />}
            {showVillaininLove && <VillaininLove onClose={() => setShowVillaininLove(false)} />}
            {showUnveiledByYou && <UnveiledByYou onClose={() => setShowUnveiledByYou(false)} />}
            {showBetterAlone && <BetterAlone onClose={() => setShowBetterAlone(false)} />}
            {showForeverYoursMyQueen && <ForeverYoursMyQueen onClose={() => setShowForeverYoursMyQueen(false)} />}
            {showRelationshipisWorship && <RelationshipisWorship onClose={() => setShowRelationshipisWorship(false)} />}
        </>
    );
};
